import { useState, useEffect, useMemo } from 'react'
import { ServiceConfig } from '@user/store/services/config'
import { getAuthHeader } from '@user/store/services/crud'
import { getBlobObjectURL } from '../../../../../../local/common/src/services/getBlobObjectURL'

const baseUrl = `${ServiceConfig.baseAPIUrl}/Proposals`

export const useGetTemplatePreview = (templateId: number) => {
  const [templatePreview, setTemplatePreview] = useState<string>()
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    let mounted = true

    const loadValue = async () => {
      if (templateId) {
        try {
          if (mounted) {
            setLoading(true)
          }

          const url = await getBlobObjectURL(
            `${baseUrl}/templates/${templateId}/preview`,
            getAuthHeader,
          )

          if (mounted) {
            setTemplatePreview(url)
          }
        } catch (e) {
          console.error(e)
          if (mounted) {
            setTemplatePreview('')
          }
        } finally {
          if (mounted) {
            setLoading(false)
          }
        }
      } else {
        if (mounted) {
          setTemplatePreview('')
        }
      }
    }

    loadValue()

    return () => {
      mounted = false
      setLoading(false)
    }
  }, [templateId])

  return useMemo(() => {
    return { templatePreview, loading }
  }, [templatePreview, loading])
}
